export default __webpack_public_path__ + "static/media/ico-11.0f4a2124.png";